module.exports = __webpack_public_path__ + "media/מטבח.215c51e8.mp3";